import { giftCodeExperienceURL } from 'endpoints';
import { setLanguageBundle } from '@nackle/intl-tools';
import fetch from '../utils/fetch';


/*******************************************************************************
 * Initial state
 */
const initialState = {
	error: '',
	loading: false,
	contentLoading: false,
	locale: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const LOADING_START = 'loading/start';
export const LOADING_END   = 'loading/end';
const CONTENT_LOADING   = 'loading/contentLoading';
export const SET_ERROR = 'state/setError';
export const CLEAR_ERROR = 'state/clearError';
export const SET_ALERT_MESSAGE   = 'state/setAlert';
export const CLEAR_ALERT_MESSAGE   = 'state/clearAlert';
export const SET_LOCALES = 'SET_LOCALES';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
	switch ( action.type ) {
		case LOADING_START: {
			return {
				...state,
				loading: true
			};
		}
		case LOADING_END: {
			return {
				...state,
				loading: false
			};
		}
		case SET_ERROR: {
			return {
				...state,
				error: action.data
			};
		}
		case CLEAR_ERROR: {
			return {
				...state,
				error: []
			};
		}
		case SET_ALERT_MESSAGE: {
			return {
				...state,
				alertMessage: {
					type: action.alertType,
					text: action.data
				}
			};
		}
		case CLEAR_ALERT_MESSAGE: {
			return {
				...state,
				alertMessage: {}
			};
		}
		case CONTENT_LOADING: {
			return {
				...state,
				contentLoading: action.flag
			};
		}
		case SET_LOCALES: {
			return {
				...state,
				locales: action.locales
			};
		}
		case UPDATE_LOCALE: {
			return {
				...state,
				locale: action.locale
			};
		}
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */
export function startLoading( ) {
	return {
		type: LOADING_START
	};
}

export function endLoading( ) {
	return {
		type: LOADING_END
	};
}

export function setError( data ) {
	return {
		type: SET_ERROR,
		data
	};
}

export function clearError( ) {
	return {
		type: CLEAR_ERROR
	};
}

export function setAlertMessage( data, alertType ) {
	return {
		type: SET_ALERT_MESSAGE,
		alertType: alertType,
		data
	};
}

export function clearAlertMessage( ) {
	return {
		type: CLEAR_ALERT_MESSAGE
	};
}

export function contentLoading( flag ) {
	return {
		type: CONTENT_LOADING,
		flag
	};
}
export function getContent( locale ) {
	return ( dispatch ) => {
		dispatch( contentLoading( true ) );
		return fetch( `${ giftCodeExperienceURL }/content`, {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			body: JSON.stringify( {
					projects: [ 'gift-code' ],
					locale: locale
			} )
		} ).then( ( res ) => {
			if ( !res.errors ) {
				return res.json().then( ( data ) => {
					if ( data ) {
						setLanguageBundle( data.locale, { ...data.properties[ 'gift-code' ] } );
					} else if ( !data.success ) {
						setLanguageBundle( locale, {} );
					}
					dispatch( contentLoading( false ) );
				} );
			} else {
				return res.json().then( ( data ) => {
					throw new Error( data );
				} );
			}
		} ).catch ( ( err ) => {
			dispatch( contentLoading( false ) );
			throw new Error( 'Error getting content' );
		} );
	};
}

export const getAllLocales = ( ) => {
	return async ( dispatch ) => {
		try {
			const res = await fetch( `${ giftCodeExperienceURL }/locales`, {
				method: 'GET',
				headers: { 'content-type': 'application/json' }
			} );

			const response = await res.json();

			if ( response.errors ) {
				throw new Error( 'Error retriving locales' );
			}

			const locales = response.locales;
			const sortedLocales = ( locales || [] ).sort( ( a, b ) => {
				return ( a.label > b.label ) ? 1 : ( ( b.label > a.label ) ? -1 : 0 );
			} );

			dispatch( setLocales( sortedLocales ) );

			return response;
		} catch ( err ) {
			console.log( err );
		}
	};
};

export const updateLocale = ( locale ) => {
	sessionStorage.setItem( 'userSessionLocale', locale );
	return {
		type: UPDATE_LOCALE,
		locale
	};
};

function setLocales( locales ) {
	return {
		type: SET_LOCALES,
		locales
	};
}